import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useModalsStore = defineStore('modals', () => {
  const modals = ref({
    auth: {
      value: false,
      props: {
        tab: 'login',
      },
    },
    sportModalStatus: false,
    customModal: null,
  })

  function pushModal(payload) {
    modals.value.customModal = payload
  }

  function setSportModalStatus(payload) {
    modals.value.sportModalStatus = payload
  }

  function closeCustomModal() {
    modals.value.customModal = null
  }

  return {
    // refs
    modals,
    // computed
    //functions
    pushModal,
    closeCustomModal,
    setSportModalStatus,
  }
})
